import { defineStore } from "pinia";
import type {
  IFooterSetting,
  IHomePageData,
  IPageDetailsResponse,
} from "~/types/home";

const getInitialData = (): IHomePageData => ({
  data: {
    header_bg_color: "",
    header_fg_color: "",
    top_banner: [],
    reward_types: [],
    bottom_banner: {
      desktop_banner: "",
      mobile_banner: "",
      location: "",
      banner_link: "",
      sort_order: "",
      status: "",
    },
    footer_bg_color: "",
    footer_fg_color: "",
    footer_settings: [],
    instagram_url: "",
    facebook_url: "",
    pinterest_url: "",
    youtube_url: "",
    linkedIn_url: "",
    twitter_url: "",
  },
});

export const useHomeStore = defineStore("homeStore", {
  state: () => ({
    homePageData: getInitialData(),
    selectedFooterLink: null as IFooterSetting | null,
    pageDetails: null as IPageDetailsResponse | null,
  }),
  actions: {
    setHomePageData(data: IHomePageData) {
      this.homePageData = data;
    },
    clearHomePageData() {
      this.homePageData = getInitialData();
      this.selectedFooterLink = null;
      this.pageDetails = null;
    },
    setSelectedFooterLink(link: IFooterSetting) {
      this.selectedFooterLink = link;
    },
    clearSelectedFooterLink() {
      this.selectedFooterLink = null;
    },
    setPageDetails(data: IPageDetailsResponse) {
      this.pageDetails = data;
    },
    clearPageDetails() {
      this.pageDetails = null;
    },
  },
  getters: {
    headerData: (state) => ({
      header_bg_color: state.homePageData.data.header_bg_color,
      header_fg_color: state.homePageData.data.header_fg_color,
    }),
    rewardTypesData: (state) => state.homePageData.data.reward_types,
    topBannerData: (state) => state.homePageData.data.top_banner,
    bottomBannerData: (state) => state.homePageData.data.bottom_banner,
    footerData: (state) => ({
      footer_bg_color: state.homePageData.data.footer_bg_color,
      footer_fg_color: state.homePageData.data.footer_fg_color,
      footer_settings: state.homePageData.data.footer_settings,
      instagram_url: state.homePageData.data.instagram_url,
      facebook_url: state.homePageData.data.facebook_url,
      pinterest_url: state.homePageData.data.pinterest_url,
      youtube_url: state.homePageData.data.youtube_url,
      linkedIn_url: state.homePageData.data.linkedIn_url,
      twitter_url: state.homePageData.data.twitter_url,
    }),
    getPageId: (state) => state.selectedFooterLink?.page_id,
    getPageName: (state) => state.selectedFooterLink?.page_name,
  },
});
